module.exports = __webpack_public_path__ + "static/media/photo_010.fdeb6d7f.JPG";